import { jsx as _jsx } from "react/jsx-runtime";
import { Menu, } from '@chakra-ui/react';
export const NavMenuContent = (props) => (_jsx(Menu.Content, { p: 0, _open: {
        animation: 'slide-from-top 0.25s ease-out',
    }, ...props }));
export const NavMenuItem = (props) => (_jsx(Menu.Item, { fontSize: 20, cursor: "pointer", py: 3, px: 4, gap: 4, width: "100%", borderRadius: 0, ...props }));
